import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import shortID from 'short-id-gen';
import { InputGroup, Intent, ProgressBar } from '@blueprintjs/core';
import { Row, Column as Col } from 'hedron';
import Modal from './Modal';
import TopToaster from '../toaster';

const initialState = {
  droppedVideo: null,
  name: null,
  description: null,
  uploadProgress: 0,
  fileExtension: null,
  createdAt: null,
  lastModified: null,
};

class VideoModal extends Modal {

  constructor(props) {
    super(props);

    this.state = initialState;

    this.onDrop = this.onDrop.bind(this);

    this.iconName = "video";
    this.title = "Neue Datei";
    this.saveButtonIcon = 'upload';
    this.initialState = initialState;
  }

  onDrop(videos) {
    if (videos && videos[0] && videos[0].name) {
      this.setState({
        droppedVideo: videos[0],
        name: this.state.name || videos[0].name,
        fileExtension: videos[0].name.split('.').pop(),
      });
    }
  }

  save() {
    console.log('upload pressed');
    if (!this.state.droppedVideo || !this.state.name) {
      return;
    }

    const videoID = shortID.generate(10);
    const filename = `${videoID}.${this.state.fileExtension}`
    const upload = this.props.customerStorageRef.child('videos').child(filename).put(this.state.droppedVideo);
    const saveState = this.state;
    const saveProps = this.props;

    const toastID = TopToaster.show({
      timeout: 0,
      iconName: 'cloud-upload',
      onDismiss: ()=>upload.cancel(),
      message: (
        <ProgressBar
          value={0}
        />
      ),
    });

    upload.on('state_changed', (snap) => {
      TopToaster.update(toastID, {
        timeout: 0,
        iconName: 'cloud-upload',
        onDismiss: ()=>upload.cancel(),
        message: (
          <ProgressBar
            value={(snap.bytesTransferred / snap.totalBytes)}
          />
        ),
      });
    }, (err) => {
      console.log(err);
    }, () => {
      console.log('Uploaded');
      saveProps.customerStorageRef.child('videos').child(filename).getDownloadURL()
      .then((url) => {
        saveProps.database.ref(`videos/${videoID}`).set({
          customer: saveProps.customerID,
          name: saveState.name,
          description: saveState.description,
          createdAt: new Date(),
          lastModified: new Date(),
          filename,
          url,
        })
        .then(() => {
          const slideID = shortID.generate(10);

          saveProps.database.ref(`slides/${slideID}`).set({
            customer: saveProps.customerID,
            name: saveState.name,
            description: saveState.description,
            template: 'fullscreenVideo',
            templateData: {
              video: videoID,
            },
            createdAt: this.state.createdAt || new Date(),
            lastModified: new Date(),
          });
          TopToaster.update(toastID, {
            timeout: 0,
            iconName: 'cloud-upload',
            message: 'Video hochgeladen',
            intent: Intent.SUCCESS,
          });
        })
        .catch((err) => {
          console.log(err);
          TopToaster.update(toastID, {
            timeout: 0,
            intent: Intent.DANGER,
            iconName: 'cloud-upload',
            message: 'Video könnte nicht hochgeladen werden.',
          });
        });
      })
      .catch((err) => {
        console.log(err);
        TopToaster.update(toastID, {
          timeout: 0,
          intent: Intent.DANGER,
          iconName: 'cloud-upload',
          message: 'Video könnte nicht hochgeladen werden.',
        });
      });
    })

    this.hide();
  }

  renderBody() {
    return (
      <Row>
        <Col sm={12}>
          <Dropzone onDrop={this.onDrop} multiple={false} disablePreview={true}>
            <div>
              {this.state.droppedVideo ? this.state.droppedVideo.name : 'Video-Datei hierher bewegen'}
            </div>
          </Dropzone>
        </Col>
        <Col sm={6}>
          <label>
            Name
            <InputGroup
              type="text"
              value={this.state.name || ''}
              placeholder={this.state.name ? null : 'Name der Datei'}
              onChange={(e) => this.setState({ name: e.target.value })}
            />
          </label>
        </Col>
        <Col sm={6}>
          <label>
            Beschreibung
            <InputGroup
              type="text"
              value={this.state.description || ''}
              placeholder="Beschreibung der Datei"
              onChange={(e) => this.setState({ description: e.target.value })}
            />
          </label>
        </Col>
      </Row>
    );
  }
}

export default VideoModal;



/** WEBPACK FOOTER **
 ** ./src/modals/VideoModal.js
 **/